module.exports = __webpack_public_path__ + "img/logo.bad423a5.svg";